/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Import_CancelledInputs */



/**
* | output |
* | --- |
* | "Import cancelled" |
*
* @param {Editor_Import_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_import_cancelled = /** @type {((inputs?: Editor_Import_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Import_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation annulee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import storniert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione annullata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт отменен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación cancelada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("进口取消")
	if (locale === "ja") return /** @type {LocalizedString} */ ("輸入はキャンセルされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात रद्द कर दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação cancelada")
	return /** @type {LocalizedString} */ ("Import cancelled")
});